module.exports = __webpack_public_path__ + "static/media/info.a283bd0c.svg";